const sourceOrigin = 'https://gemsafe.cn'
const targetOrigin = 'https://www.gemsafe.cn'

export default function restoreLogin(startApp) {
  let shouldRestore = false
  try {
    shouldRestore = window.location.origin === targetOrigin && !localStorage.getItem('loginUserInfo')
  } catch (error) {
    // 存储不可用时直接启动。
  }
  if (!shouldRestore) {
    startApp()
    return
  }
  const frame = document.createElement('iframe')
  frame.hidden = true
  frame.setAttribute('aria-hidden', 'true')
  frame.src = sourceOrigin + '/static/login-storage-bridge.html'
  let finished = false
  let timeout
  function finish() {
    if (finished) return
    finished = true
    clearTimeout(timeout)
    window.removeEventListener('message', receive)
    if (frame.parentNode) frame.parentNode.removeChild(frame)
    startApp()
  }
  function receive(event) {
    if (event.origin !== sourceOrigin || event.source !== frame.contentWindow) return
    if (!event.data || event.data.type !== 'mall-login-response') return
    try {
      const value = event.data.value
      if (typeof value === 'string' && value) {
        const info = JSON.parse(value)
        if (info && typeof info === 'object' && !Array.isArray(info) &&
          !localStorage.getItem('loginUserInfo')) {
          localStorage.setItem('loginUserInfo', value)
        }
      }
    } catch (error) {
      // 数据无效或存储不可用时仍正常启动。
    }
    finish()
  }
  window.addEventListener('message', receive)
  frame.onload = () => {
    if (!finished) frame.contentWindow.postMessage({ type: 'mall-login-request' }, sourceOrigin)
  }
  frame.onerror = finish
  // 桥接页未部署或被限制时，最多等待三秒。
  timeout = setTimeout(finish, 3000)
  document.body.appendChild(frame)
}



// WEBPACK FOOTER //
// ./src/utils/restoreLogin.js